import { Button } from "react-bootstrap";
import Slider from "react-slick";

const MainSlider = ({ banners }) => {
  const settings = {
    dots: true,
    // fade: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        {banners &&
          banners?.length &&
          banners?.map((b, index) => {
            return (
              <div className="position-relative" key={index}>
                <img src={b.link} alt="First Slide" />
                {(b?.ctabtns?.length > 0 &&
                  b?.ctabtns?.map((c, i) => {
                    return (
                      <div key={i} className="banner-btn">
                        <Button
                          variant="primary"
                          className="start-btn"
                          onClick={() => {
                            window.location.href = c.actionLink;
                          }}
                        >
                          {c.label}
                        </Button>
                      </div>
                    );
                  })) ||
                  null}
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default MainSlider;
